// extracted by css-extract-rspack-plugin
export default {"line":"line-PUh1ML"};